// import "jquery";
import Router from "./util/Router";

import common from "./routes/common";
import home from "./routes/home";
import singleProduct from "./routes/single-product";
import pageTemplateConsultation from "./routes/page-template-consultation";
import postTypeArchiveProduct from "./routes/post-type-archive-product";
import pageTemplateFaqs from "./routes/page-template-faqs";
import woocommerceCart from "./routes/woocommerce-cart";
import woocommerceCheckout from "./routes/woocommerce-checkout";
import woocommerceAccountViewConsultation from "./routes/woocommerce-account-view-consultation";
import woocommerceAccountViewSubscription from "./routes/woocommerce-account-view-subscription";
import woocommerceAccountDashboard from "./routes/woocommerce-account-dashboard";
import woocommerceAccountEditAccount from "./routes/woocommerce-account-edit-account";
import woocommerceAccountLostPassword from "./routes/woocommerce-account-lost-password";
import woocommerceAccount from "./routes/woocommerce-account";

const singleConsultationConfig = pageTemplateConsultation;

const pageTemplatePageLanding = home;
const pageTemplateVitamins = postTypeArchiveProduct;
const pageTemplateBundles = postTypeArchiveProduct;

const routes = new Router({
    common,
    home,
    pageTemplateConsultation,
    singleConsultationConfig,
    postTypeArchiveProduct,
    pageTemplateFaqs,
    pageTemplateVitamins,
    pageTemplateBundles,
    woocommerceCart,
    woocommerceCheckout,
    singleProduct,
    woocommerceAccountViewConsultation,
    woocommerceAccountViewSubscription,
    woocommerceAccountDashboard,
    woocommerceAccountEditAccount,
    woocommerceAccountLostPassword,
    woocommerceAccount,
    pageTemplatePageLanding
});

function ready(func) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
        func();
    } else {
        document.addEventListener("DOMContentLoaded", func);
    }
}

ready(function () {
    routes.loadEvents();

    var accountFirstName = jQuery('#account_first_name');
    var accountLastName = jQuery('#account_last_name');
    var surveyInput = jQuery('#surveyContainer.form-control');

    // First letter uppercase
    var elementFirstUpper = function(el) {
        el.keyup(function() {
            var str = el.val().toLowerCase();

            var spart = str.split(" ");
            for ( var i = 0; i < spart.length; i++ )
            {
                var j = spart[i].charAt(0).toUpperCase();
                spart[i] = j + spart[i].substr(1);
            }
            el.val(spart.join(" "));
        });
    };

    elementFirstUpper(accountFirstName);
    elementFirstUpper(accountLastName);
    elementFirstUpper(surveyInput);
});



// WEBPACK FOOTER //
// ./js/main.js